
import { Options, Vue } from "vue-class-component"; //基本需要\

import roma from "../assets/json1/roma.js";
import * as echarts from "echarts";
import passion1 from "@/assets/js/passion1.js";
import { store } from "@/store"; //引入仓库
import { ElMessage } from "element-plus";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import TableView from "./TableView.vue";
import {
  dispatchMemoryResouceSpeedOptions,
  dispatchMemoryResouceVehicle,
} from "@/store/performance/actions";
// import God from "@/assets/js/god.js";
import {
  readGetMemoryResouceOptions,
  readGetMemoryResouceVehice,
} from "@/store/performance/getters";
import { s } from "@fullcalendar/core/internal-common.js";
@Options({
  components: {
    TableView,
  },
})
export default class TestReport extends Vue {
  drawLine(v) {
    // 写死的部件名称
    const parts = ["部件 A", "部件 B", "部件 C"];

    // 假设每个部件的随机数据（可以根据需要修改）
    const data = {
      "部件 A": 12,
      "部件 B": 18,
      "部件 C": 25,
    };

    // 计算均值
    const average =
      Object.values(data).reduce((a, b) => a + b, 0) / parts.length;

    // Series 数据
    const series = [
      {
        name: v, // 循环的变量作为柱子名称
        type: "bar",
        data: parts.map((part) => data[part]), // 部件数据
      },
      {
        name: "均值", // 均值柱子名称
        type: "bar",
        data: parts.map(() => average), // 所有部件的均值
      },
    ];

    // 配置项
    const option = {
      legend: {
        data: [v, "均值"],
      },
      grid: {
        left: 100,
        right: 100,
        top: 50,
        bottom: 50,
      },
      xAxis: {
        type: "category",
        data: parts, // X 轴为部件名称
      },
      yAxis: {
        type: "value",
      },
      series,
    };

    // 获取图表容器并绘制图表
    const chartDiv = document.getElementById(v);
    const chart = echarts.init(chartDiv);
    chart.setOption(option);
  }
  public drawHistory() {
    let performance_line = document.getElementById("triangles_pie_history");
    echarts.dispose(performance_line);
    let contrastChart = echarts.init(performance_line);

    const xData = [
      "2023-09-01",
      "2023-09-02",
      "2023-09-03",
      "2023-09-04",
      "2023-09-05",
    ]; // 时间数据
    const yData = {
      汽车: [120, 132, 101, 134, 90],
      轮胎: [220, 182, 191, 234, 290],
      方向盘: [150, 212, 201, 154, 190],
    };

    // 模拟 series 数据
    const seriesData = Object.keys(yData).map((key) => ({
      name: key,
      type: "line", // 或 'bar' 取决于需要的图表类型
      data: yData[key],
    }));

    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: Object.keys(yData), // Y 轴字段名称
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
      },
      yAxis: {
        type: "value",
        name: "MB",
        axisTick: false,
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: xData, // X 轴时间数据
      },
      series: seriesData, // 使用模拟的 series 数据
    });
  }
  drawAvg(chartId) {
    // 写死的数据
    const rawData = [
      [100, 302, 301, 334, 390, 330, 320],
      [320, 132, 101, 134, 90, 230, 210],
      [220, 182, 191, 234, 290, 330, 310],
      [150, 212, 201, 154, 190, 330, 410],
      [820, 832, 901, 934, 1290, 1330, 1320],
    ];
    const parts = ["部件 A", "部件 B", "部件 C", "部件 D", "部件 E"];

    const totalData = [];
    for (let i = 0; i < rawData[0].length; ++i) {
      let sum = 0;
      for (let j = 0; j < rawData.length; ++j) {
        sum += rawData[j][i];
      }
      totalData.push(sum);
    }

    const grid = {
      left: 100,
      right: 100,
      top: 50,
      bottom: 50,
    };

    const series = parts.map((name, sid) => {
      return {
        name,
        type: "bar",
        stack: "total",
        barWidth: "60%",
        label: {
          show: true,
          formatter: (params) => Math.round(params.value * 1000) / 10 + "%",
        },
        data: rawData[sid].map((d, did) =>
          totalData[did] <= 0 ? 0 : d / totalData[did]
        ),
      };
    });

    const option = {
      legend: {
        selectedMode: false,
      },
      grid,
      yAxis: {
        type: "value",
      },
      xAxis: {
        type: "category",
        data: parts, // X 轴为部件名称
      },
      series,
    };

    const chartDiv = document.getElementById(chartId);
    const chart = echarts.init(chartDiv);
    chart.setOption(option);
  }
  public get averageAvg_tris_series() {
    const colorPairs = [
      ["rgb(0, 221, 255)", "rgb(77, 119, 255)"],
      ["rgb(255, 0, 135)", "rgb(135, 0, 255)"],
      ["rgb(255, 191, 0)", "rgb(255, 48, 79)"],
      // 更多颜色组合
    ];
    function getColor(index: number) {
      const colors = colorPairs[index % colorPairs.length];
      return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: colors[0] },
        { offset: 1, color: colors[1] },
      ]);
    }
    return this.averageAvg_tris_device.map((v, index) => ({
      name: v,
      type: "line",
      stack: "Total",
      smooth: true,
      lineStyle: {
        width: 0,
      },
      showSymbol: false,
      emphasis: {
        focus: "series",
      },
      areaStyle: {
        opacity: 0.8,
        color: getColor(index), // 使用函数返回渐变颜色
      },
      data: Object.values(this.averageData.avg_tris_data[v]).map(
        (item: any) => item.avg_tris
      ),
    }));
  }
  public averageAvg_dc_series() {
    const colorPairs = [
      ["rgb(0, 221, 255)", "rgb(77, 119, 255)"],
      ["rgb(255, 0, 135)", "rgb(135, 0, 255)"],
      ["rgb(255, 191, 0)", "rgb(255, 48, 79)"],
      // 更多颜色组合
    ];
    function getColor(index: number) {
      const colors = colorPairs[index % colorPairs.length];
      return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: colors[0] },
        { offset: 1, color: colors[1] },
      ]);
    }
    return this.averageAvg_dc_device.map((v, index) => ({
      name: v,
      type: "line",
      stack: "Total",
      smooth: true,
      lineStyle: {
        width: 0,
      },
      showSymbol: false,
      emphasis: {
        focus: "series",
      },
      areaStyle: {
        opacity: 0.8,
        color: getColor(index), // 使用函数返回渐变颜色
      },
      data: Object.values(this.averageData.avg_dc_data[v]).map(
        (item: any) => item.avg_dc
      ),
    }));
  }
  averageData = {
    avg_tris_data: {
      "部件 A": [{ avg_tris: 10 }, { avg_tris: 15 }, { avg_tris: 20 }],
      "部件 B": [{ avg_tris: 12 }, { avg_tris: 18 }, { avg_tris: 25 }],
      "部件 C": [{ avg_tris: 8 }, { avg_tris: 14 }, { avg_tris: 19 }],
    },
    avg_dc_data: {
      "部件 X": [{ avg_dc: 5 }, { avg_dc: 10 }, { avg_dc: 15 }],
      "部件 Y": [{ avg_dc: 7 }, { avg_dc: 12 }, { avg_dc: 18 }],
      "部件 Z": [{ avg_dc: 6 }, { avg_dc: 11 }, { avg_dc: 14 }],
    },
  };

  // 设备列表
  averageAvg_tris_device = ["部件 A", "部件 B", "部件 C"];
  averageAvg_dc_device = ["部件 X", "部件 Y", "部件 Z"];
  public drawResPie(item) {
    let performance_line: any = document.getElementById(item);
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      title: {
        text:
          "总大小" +
          (item == "triangles_pie"
            ? this.piechartData.reduce(
                (accumulator, current) => accumulator + current.DC_Percent,
                0
              )
            : this.piechartData.reduce(
                (accumulator, current) => accumulator + current.Tris_Percent,
                0
              )),

        left: "center",
      },

      animation: false,
      // backgroundColor: 'rgb(13, 13, 13)',
      tooltip: {
        trigger: "item",
        // formatter: (params: any) => {
        //   var str = "";
        //   //首先要看看params是怎样的数据结构，里面有什么内容;

        //   //对params进行操作
        //   return (
        //     params.data.name +
        //     ":" +
        //     this.sizeCompany(params.data.value) +
        //     "(" +
        //     params.percent +
        //     "%)"
        //   );
        // },
      },

      series: [
        {
          type: "pie",
          radius: "80%",
          center: ["50%", "58%"], // 调整饼图的位置
          data:
            item == "triangles_pie"
              ? this.piechartData.map((item) => {
                  return { name: item.Part_Name, value: item.DC_Percent };
                })
              : this.piechartData.map((item) => {
                  return { name: item.Part_Name, value: item.Tris_Percent };
                }),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          itemStyle: {
            normal: {
              label: {
                show: true,
                formatter: "{d}%",
                position: "inside",
                color: "#fff",
              },
              labelLine: { show: false },
            },
          },
        },
      ],
    });
  }
  public piechartData = [
    { Part_Name: "部分 A", DC_Percent: 30, Tris_Percent: 40 },
    { Part_Name: "部分 B", DC_Percent: 20, Tris_Percent: 25 },
    { Part_Name: "部分 C", DC_Percent: 25, Tris_Percent: 15 },
    { Part_Name: "部分 D", DC_Percent: 15, Tris_Percent: 20 },
    { Part_Name: "部分 E", DC_Percent: 10, Tris_Percent: 5 },
  ];
  public localProject = Number(getLocalProject()); //得到本地的项目
  public b = "40%";
  public nameList = ["河豚机甲"];
  public loading = false;
  public result_vehicles_columns = [];
  public skin_list = ["皮肤1", "皮肤2", "皮肤3"];
  public sub_skin = "";
  public sub_car = "";
  public car_name = "";
  public scan_id = "";
  public date = "";
  public versions = "";
  public result_Versions = [];
  public result_ScanTime = [];
  public result_RecordID = [];
  public result_AssetType = [];
  public result_AssetSubType = [];
  public result_AssetID = [];
  public result_vehicles_Parts_columns = [];
  public result_animate_list_columns = [];
  public result_materia_list_columns = [];
  public result_texture_list_columns = [];
  public result_meshres_list_columns = [];
  public resouceChange() {
    this.resouce_loading = true;
    this.resourceVehice_api();
  }
  public resouce_loading = false;
  public get resource_vehicle() {
    return readGetMemoryResouceVehice(store);
  }
  public async resourceVehice_api() {
    await dispatchMemoryResouceVehicle(store, {
      project: this.localProject,
      Versions: this.versions,
      ScanTime: this.date,
      RecordID: this.scan_id,
      AssetID: this.sub_skin,
      AssetType: this.car_name,
      AssetSubType: this.sub_car,
    });
    if (this.resource_vehicle.result_vehicles.length > 0) {
      this.result_vehicles_columns = Object.keys(
        this.resource_vehicle.result_vehicles[0]
      );
    }
    if (this.resource_vehicle.result_vehicles_Parts.length > 0) {
      this.result_vehicles_Parts_columns = Object.keys(
        this.resource_vehicle.result_vehicles_Parts[0]
      );
    }
    if (this.resource_vehicle.result_meshres_list.length > 0) {
      this.result_meshres_list_columns = Object.keys(
        this.resource_vehicle.result_meshres_list[0]
      );
    }
    if (this.resource_vehicle.result_animate_list.length > 0) {
      this.result_animate_list_columns = Object.keys(
        this.resource_vehicle.result_animate_list[0]
      );
    }
    if (this.resource_vehicle.result_materia_list.length > 0) {
      this.result_materia_list_columns = Object.keys(
        this.resource_vehicle.result_materia_list[0]
      );
    }
    if (this.resource_vehicle.result_texture_list.length > 0) {
      this.result_texture_list_columns = Object.keys(
        this.resource_vehicle.result_texture_list[0]
      );
    }

    this.resouce_loading = false;
  }
  public get resourceOptons() {
    return readGetMemoryResouceOptions(store);
  }
  public async options_api() {
    await dispatchMemoryResouceSpeedOptions(store, {
      project: this.localProject,
    });
    this.result_Versions = this.resourceOptons.result_Versions;
    this.result_ScanTime = this.resourceOptons.result_ScanTime;
    this.result_RecordID = this.resourceOptons.result_RecordID;
    this.result_AssetType = this.resourceOptons.result_AssetType;
    this.result_AssetSubType = this.resourceOptons.result_AssetSubType;
    this.result_AssetID = this.resourceOptons.result_AssetID;
    this.versions = this.result_Versions[0];
    this.date = this.result_ScanTime[0];
    this.scan_id = this.result_RecordID[0];
    this.car_name = this.result_AssetType[0];
    this.sub_car = this.result_AssetSubType[0];
    this.sub_skin = this.result_AssetID[0];
  }
  public async mounted() {
    const list = ["triangles_pie", "MaxDrawCalls_pie"];
    this.drawHistory();
    list.forEach((v) => {
      this.drawResPie(v);
    });
    const list_1 = ["triangles", "MaxDrawCalls"];
    list_1.forEach((v) => {
      this.drawAvg(v);
    });
    const list_2 = ["triangles_line", "MaxDrawCalls_line"];
    list_2.forEach((v) => {
      this.drawLine(v);
    });
    this.resouce_loading = true;
    await this.options_api();
    this.resourceVehice_api();
    // this.dataFromParent.forEach((n,index)=>{
    //       this.skin_list.forEach(v=>{
    //     this.draw_test(v+'_'+String(index))
    // })
    // })
  }
  public draw_test(item) {
    let performance_line: any = document.getElementById(item);
    echarts.dispose(performance_line);
    const rawData = {
      轮胎: [120, 132, 101, 134, 90, 100, 90],
      车身: [220, 182, 191, 234, 290, 50, 70],
      赛车: [420, 25, 91, 234, 290, 50, 70],
    };
    const totalData = [];
    for (let i = 0; i < rawData["轮胎"].length; ++i) {
      let sum = 0;
      for (let key in rawData) {
        sum += rawData[key][i];
      }
      totalData.push(sum);
    }
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      title: {
        text: item.split("_")[0],
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["DC", "Tris", "Batches", "MaxBatches", "SetPassCall"],
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      xAxis: {
        type: "category",
        data: ["DC", "Tris", "Batches", "MaxBatches", "SetPassCall"],
        axisLabel: {
          interval: 0, // 显示所有标签
        },
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: "轮胎",
          type: "bar",
          stack: "堆叠",
          barWidth: "60%",
          data: rawData["轮胎"],
          label: {
            show: true,
            formatter: function (params) {
              // params.dataIndex 是当前坐标的索引
              let total = totalData[params.dataIndex];
              let percent = ((params.value / total) * 100).toFixed(2) + "%";
              return percent;
            },
          },
        },
        {
          name: "车身",
          type: "bar",
          stack: "堆叠",
          barWidth: "60%",
          data: rawData["车身"],
          label: {
            show: true,
            formatter: function (params) {
              // params.dataIndex 是当前坐标的索引
              let total = totalData[params.dataIndex];
              let percent = ((params.value / total) * 100).toFixed(2) + "%";
              return percent;
            },
          },
        },
        {
          name: "赛车",
          type: "bar",
          stack: "堆叠",
          barWidth: "60%",
          data: rawData["赛车"],
          label: {
            show: true,
            formatter: function (params) {
              // params.dataIndex 是当前坐标的索引
              let total = totalData[params.dataIndex];
              let percent = ((params.value / total) * 100).toFixed(2) + "%";
              return percent;
            },
          },
        },
      ],
    });
  }
  public dataFromParent = [
    {
      name: "动态扫描",
      data: [
        {
          name: "轮胎",
          轮胎: {
            皮肤1: {
              DC: "2",
              Tris: "3",
            },
            皮肤2: {
              DC: "2",
              Tris: "3",
            },
            皮肤3: {
              DC: "2",
              Tris: "3",
            },
          },
        },
        {
          name: "车身",
          车身: {
            皮肤1: {
              DC: "2",
              Tris: "3",
            },
            皮肤2: {
              DC: "2",
              Tris: "3",
            },
            皮肤3: {
              DC: "2",
              Tris: "3",
            },
          },
        },
        {
          name: "图表",
          图表: {
            皮肤1: {
              DC: "2",
              Tris: "3",
            },
            皮肤2: {
              DC: "2",
              Tris: "3",
            },
            皮肤3: {
              DC: "2",
              Tris: "3",
            },
          },
        },
      ],
    },
    {
      name: "真机扫描",
      data: [
        {
          name: "轮胎",
          轮胎: {
            皮肤1: {
              DC: "2",
              Tris: "3",
            },
            皮肤2: {
              DC: "2",
              Tris: "3",
            },
            皮肤3: {
              DC: "2",
              Tris: "3",
            },
          },
        },
        {
          name: "车身",
          车身: {
            皮肤1: {
              DC: "2",
              Tris: "3",
            },
            皮肤2: {
              DC: "2",
              Tris: "3",
            },
            皮肤3: {
              DC: "2",
              Tris: "3",
            },
          },
        },
        {
          name: "图表",
          图表: {
            皮肤1: {
              DC: "2",
              Tris: "3",
            },
            皮肤2: {
              DC: "2",
              Tris: "3",
            },
            皮肤3: {
              DC: "2",
              Tris: "3",
            },
          },
        },
      ],
    },
  ];
}
